/**
 * User Account API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareDto } from './shareDto';
import { RequestedShare } from './requestedShare';


export interface GroupDto { 
    id?: number;
    label?: string;
    role?: GroupDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
    membersIds?: Array<number>;
}
export namespace GroupDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


